class Config {
  constructor () {
    this.videoStaticBackendBaseURL = 'https://www.for-paper-video.binyi.fun/videos/'
    this.basicBackendBaseURL = 'https://www.for-paper-proxy.binyi.fun/'
  }
}

export default new Config()
